import { render } from "./Contenedor2.vue?vue&type=template&id=78f67da4&scoped=true"
import script from "./Contenedor2.vue?vue&type=script&lang=js"
export * from "./Contenedor2.vue?vue&type=script&lang=js"

import "./Contenedor2.vue?vue&type=style&index=0&id=78f67da4&scoped=true&lang=css"

import exportComponent from "/Users/bencorp/Desktop/proyectos/Fitbar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f67da4"]])

export default __exports__